/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ReactNode, useMemo } from "react";
import { ToggleItemBox, BaselineTag, ActionNameDisplay } from "~/components";
import { baselineTagToShow, getFlatPlanEntities } from "~/utils";
import { PlanField } from "~/views/plans/PlanCreate/components/PlanCreateWizard/constants";
import { usePlanWizard } from "~/views/plans/PlanCreate/components/PlanCreateWizard/PlanProvider";
import { PlanActionTypeExtended, usePlan } from "../../PlanProvider";

export function ActionItem({
  entity,
  onMouseDown,
  renderEditableName,
}: {
  entity: PlanActionTypeExtended;
  renderEditableName: (name: string) => ReactNode;
  onMouseDown: () => void;
}) {
  const { planAction } = usePlan();
  const { planData } = usePlanWizard();

  const baselineTag = useMemo(
    () =>
      baselineTagToShow(
        entity,
        getFlatPlanEntities(
          planData?.[PlanField.PLAN_SETTINGS]?.planEntities ?? []
        )
      ),
    [entity, planData]
  );

  return (
    <ToggleItemBox
      item={{
        id: entity.id ?? "",
        color: entity?.action?.color ?? "",
        name: (
          <div>
            <ActionNameDisplay
              actionName={entity.action?.name || entity.actionName || ""}
              customName={entity.name || ""}
              actionType={entity.actionType}
              renderEditableName={renderEditableName}
            />
          </div>
        ),
        onMouseDown,
      }}
      tag={baselineTag ? <BaselineTag tag={baselineTag} /> : undefined}
      active={planAction?.listId === entity.listId}
    />
  );
}
